import React from 'react';

const ServiceSelfLifeDetails = ({ProductData}) => {

    return (
        <div>
            <div className="border rounded-lg p-6 shadow-sm">
            <div className="p-[10px] border-b border-[#3333338a]">
                <h1 className="text-[#333] text-xl font-semibold ps-[10px]">Self Life & Expiry Details</h1>
            </div>
            <div>
                <div className='py-4 flex items-center gap-3 '>
                    <p className="font-semibold text-[#333] w-fit">Service Life :</p>
                    <p> {ProductData?.p_life || '-'} {ProductData?.p_lifespan || '-'}</p>
                    </div>
            </div>
            </div>
        </div>
    );
};

export default ServiceSelfLifeDetails;
